import { useCallback, useEffect, useRef, useState } from "react";

function getDevice() {
  if (window.innerWidth > 1200) return "desktop";
  if (window.innerWidth > 1000) return "laptop";
  if (window.innerWidth > 768) return "tablet";
  return "phone";
}

export function useDetectDevice() {
  const [device, setDevice] = useState(getDevice());
  const interval = useRef(null);

  const handleResize = useCallback(() => {
    clearInterval(interval);
    setDevice(getDevice());
  }, []);

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [handleResize]);

  return device;
}
